<!--
 * @Description: 任务查询——系列销量目标||月度
 * @Autor: txp
 * @Date: 2021-04-02 21:11:13
-->
<template>
  <div class="taskDetail">
    <el-card class="box-card">
      <div class="ft12 C787878">
        <span>您现在的位置：</span>
        <span>
          <a href="#" class="text-decoration_none themColor" @click="goHomes">返回上一页</a>
        </span>
        <span class="el-icon-arrow-right"></span>
        <span>销量目标</span>
      </div>
      <div class="form-container">
        <el-form size="small" label-width="100px" disabled label-position="right" class="form">
          <el-form-item label="对象纬度">
            <el-select v-model="form.objectType" class="item-width">
              <el-option
                v-for="item in objectTypeList"
                :key="item.dictCode"
                :label="item.dictValue"
                :value="item.dictCode"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="销量目标类型">
            <el-select v-model="form.type" class="item-width">
              <el-option
                v-for="item in typeList"
                :key="item.dictCode"
                :label="item.dictValue"
                :value="item.dictCode"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="任务类型">
            <el-select v-model="form.taskType" class="item-width">
              <el-option
                v-for="item in taskTypeList"
                :key="item.dictCode"
                :label="item.dictValue"
                :value="item.dictCode"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="销量目标名称">
            <el-input v-model="form.name" class="item-width" />
          </el-form-item>
          <el-form-item label="客户名称" v-if="this.form.objectType == 1">
            <el-input v-model="form.cusName" class="item-width" />
          </el-form-item>
          <el-form-item label="客户编码" v-if="this.form.objectType == 1">
            <el-input v-model="form.cusCode" class="item-width" />
          </el-form-item>
          <el-form-item label="销售区域" v-if="this.form.objectType == 2">
            <el-input v-model="form.salesArea" class="item-width" />
          </el-form-item>
          <el-form-item label="组织名称" v-if="this.form.objectType == 2">
            <el-input v-model="form.orgName" class="item-width" />
          </el-form-item>
          <el-form-item label="组织编码" v-if="this.form.objectType == 2">
            <el-input v-model="form.orgCode" class="item-width" />
          </el-form-item>
        </el-form>
      </div>
      <!-- 表格数据 -->
      <div class="table-container">
        <el-table
          :summary-method="getSummaries"
          show-summary
          :data="tableData"
          element-loading-spinner="el-icon-loading"
           v-loading="loading"
          :header-cell-style="{
            fontSize: '13px',
            color: '#787878',
            background: '#F5F5F5',
            textAlign: 'center',
          }"
          :cell-style="{
            fontSize: '14px',
            color: '#140000',
            textAlign: 'center',
          }"
          style="width: 100%"
        >
          <el-table-column align="center" type="index" label="序号" fixed="left">
          </el-table-column>
          <el-table-column align="center" prop="productLevelName" label="产品层级" fixed="left" v-if="productType>1">
          </el-table-column>
          <el-table-column align="center" prop="productLevelCode" label="产品层级编码" fixed="left"  width="120" v-if="productType>1">
          </el-table-column>
          <el-table-column align="center" prop="goodsName" label="商品名称" fixed="left" v-if="productType == 1">
          </el-table-column>
          <el-table-column align="center" prop="goodsCode" label="商品编码" fixed="left"  width="120" v-if="productType == 1">
          </el-table-column>
          <el-table-column align="center" prop="targetYear" label="年度" fixed="left">
          </el-table-column>
          <el-table-column align="center" prop="yearlySum" label="年总量" fixed="left">
          </el-table-column>
          <el-table-column align="center" prop="janTargetNum" label="一月" v-if="month">
          </el-table-column>
          <el-table-column align="center" prop="febTargetNum" label="二月" v-if="month">
          </el-table-column>
          <el-table-column align="center" prop="marTargetNum" label="三月" v-if="month">
          </el-table-column>
          <el-table-column align="center" prop="aprTargetNum" label="四月" v-if="month">
          </el-table-column>
          <el-table-column align="center" prop="mayTargetNum" label="五月" v-if="month">
          </el-table-column>
          <el-table-column align="center" prop="junTargetNum" label="六月" v-if="month">
          </el-table-column>
          <el-table-column align="center" prop="julTargetNum" label="七月" v-if="month">
          </el-table-column>
          <el-table-column align="center" prop="augTargetNum" label="八月" v-if="month">
          </el-table-column>
          <el-table-column align="center" prop="sepTargetNum" label="九月" v-if="month">
          </el-table-column>
          <el-table-column align="center" prop="octTargetNum" label="十月" v-if="month">
          </el-table-column>
          <el-table-column align="center" prop="novTargetNum" label="十一月" v-if="month">
          </el-table-column>
          <el-table-column align="center" prop="decTargetNum" label="十二月" v-if="month">
          </el-table-column>
          <el-table-column align="center" prop="yearlyNum" label="年度销量" v-if="year">
          </el-table-column>
          <el-table-column align="center" prop="firstQuarterNum" label="第一季度" v-if="jidu">
          </el-table-column>
          <el-table-column align="center" prop="secondQuarterNum" label="第二季度" v-if="jidu">
          </el-table-column>
          <el-table-column align="center" prop="thirdQuarterNum" label="第三季度" v-if="jidu">
          </el-table-column>
          <el-table-column align="center" prop="fourthQuarterNum" label="第四季度" v-if="jidu">
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>
<script>
import { taskDetail, getBatchDictSelect } from '@/api/api'

export default {
  data() {
    return {
      name: 'first',
      tableData: [],//表格数据
      taskType: '',
      activeName: 'first',
      form: {
        objectType: '', //对象纬度
        type: '', //销量目标类型
        taskType: '', //任务类型
        name: '', //销量目标名称
        cusName: '', //客户名称
        cusCode: '', //客户编码
        salesArea: '', //销售区域
        orgName: '', //组织名称
        orgCode: '' //组织编码
      },
      objectTypeList: [], //对象纬度下拉数据
      typeList: [], //销量目标类型下拉数据
      taskTypeList: [], //任务类型下拉数据
      loading:false,//表格在数据请求成功前加载
      productType:0,// 产品
      month:false,//月度
      jidu:false,//季度
      year:false,//年度
    }
  },
  created() {
    this.getDictData()
    const { id } = this.$route.query
    this.getInfo(id)
  },
  methods: {
    //获取详情
    getInfo(id) {
      taskDetail(id).then((res) => {
        let arr = {...res.result.saleGoalItemVo,...res.result}
        this.tableData.push(arr)
        // 1、产品
        this.productType = this.tableData[0].type
        // 2、年度、月度、季度的显示与隐藏
        this.month = this.tableData[0].taskType == 3 ? true :  false // 月度
        this.jidu = this.tableData[0].taskType == 2 ? true :  false // 季度
        this.year = this.tableData[0].taskType == 1 ? true :  false // 年度
        this.loading = false
        this.form = res.result
        this.form.objectType = this.form.objectType.toString()
        this.form.type = this.form.type.toString()
        this.form.taskType = this.form.taskType.toString()
      })
    },
    goHomes() {
      window.history.back()
    },
    //获取所有数据字典
    getDictData() {
      const params = ['sales_target_dimension', 'salesTarget_type', 'dms_target_task']
      getBatchDictSelect(params).then((res) => {
        if (res.success) {
          this.objectTypeList = res.result.sales_target_dimension
          this.typeList = res.result.salesTarget_type
          this.taskTypeList = res.result.dms_target_task
        }
      })
    },
    // 合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = '--';
        }
        if(column.property == 'targetYear'){
          sums[index] = '--';
        }
      });

      return sums;
    }
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
.taskDetail {
  height: 100%;
  /deep/ .el-card {
    height: 100%;
  }
}
.form-container {
  padding: 30px 40px;
}
.form {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .item-width {
    width: 300px;
  }
}
// 滚动条的宽度
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
  width: 6px ; // 横向滚动条
  height: 10px; // 纵向滚动条
}
// 滚动条的滑块
/deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 10px;
}
</style>
